<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">From the options listed below, Pick the correct structure for fluorene.</p>

      <v-radio-group v-model="inputs.input1" class="mb-0" :disabled="!allowEditing">
        <v-radio class="my-2 pb-2" value="isomer3">
          <template #label>
            <v-img :src="imageAName" max-width="190px" />
          </template>
        </v-radio>

        <v-radio class="my-2" value="isomer1">
          <template #label>
            <v-img :src="imageBName" max-width="143px" />
          </template>
        </v-radio>

        <v-radio class="my-2 pt-2" value="isomer2">
          <template #label>
            <v-img :src="imageCName" max-width="193px" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'ChemUCI51LBA1Q1',
  components: {
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
      },
    };
  },
  computed: {
    imageAName() {
      return prefixPublicAsset('/img/assignments/uci-51lb-a1-q1-option1.png');
    },
    imageBName() {
      return prefixPublicAsset('/img/assignments/uci-51lb-a1-q1-option2.png');
    },
    imageCName() {
      return prefixPublicAsset('/img/assignments/uci-51lb-a1-q1-option3.png');
    },
  },
};
</script>
